"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionInferenceReportEntrySchema = void 0;
const zod_1 = require("zod");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
const IComponentFunction_1 = require("../FunctionalModels/IComponentFunction");
exports.ComponentFunctionInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('model')
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil')),
    priority: zod_1.z.number().optional(),
    function: IComponentFunction_1.IComponentFunctionSchema,
});
//# sourceMappingURL=ComponentFunctionInferenceReportEntry.js.map